import { render } from "./Leaf.vue?vue&type=template&id=32da3a3c&scoped=true&ts=true"
import script from "./Leaf?vue&type=script&lang=ts"
export * from "./Leaf?vue&type=script&lang=ts"

import "./Leaf.scss?vue&type=style&index=0&id=32da3a3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32da3a3c"]])

export default __exports__